import Vue from 'vue'

import ElementUI, { Table } from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'

const fixElTableErr = (table) => {
  const oldResizeListener = table.methods.resizeListener;
  table.methods.resizeListener = function () {
      window.requestAnimationFrame(oldResizeListener.bind(this));
  };
};
// 一定要在Vue.use之前执行此函数
fixElTableErr(Table);

Vue.use(ElementUI)
